import React from 'react';

const PersonIcon = ({ className }) => (
    <svg
        width='48'
        height='49'
        viewBox='0 0 48 49'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <path
            d='M40 42.5V38.5C40 36.3783 39.1571 34.3434 37.6568 32.8431C36.1566 31.3429 34.1217 30.5 32 30.5H16C13.8783 30.5 11.8434 31.3429 10.3431 32.8431C8.84285 34.3434 8 36.3783 8 38.5V42.5M32 14.5C32 18.9183 28.4183 22.5 24 22.5C19.5817 22.5 16 18.9183 16 14.5C16 10.0817 19.5817 6.5 24 6.5C28.4183 6.5 32 10.0817 32 14.5Z'
            stroke='#475467'
            strokeWidth='4'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export { PersonIcon };
